import { Icon } from '@purpur/library/icon';
import styled, { css } from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

type Params = {
    $iconPosition: 'left' | 'right';
    $hasExtraSpacing?: boolean;
};

export const StyledIcon = styled(Icon)<Params>`
    flex-shrink: 0;
    ${({ $iconPosition, $hasExtraSpacing }) =>
        $hasExtraSpacing &&
        $iconPosition === 'left' &&
        css`
            margin-right: ${getPurpurSpacing('100')};
        `}
    ${({ $iconPosition, $hasExtraSpacing }) =>
        $hasExtraSpacing &&
        $iconPosition === 'right' &&
        css`
            margin-left: ${getPurpurSpacing('100')};
        `}
`;
